import type { MoneyAmount } from 'types'
import type { MarketplacePurchase } from 'utils/web_api.schemas'

import { CurrentBalance } from './CurrentBalance'
import CardPaymentDetails from '../checkout/payments/CardPaymentDetails'
import CostBreakdown from '../checkout/summary/CostBreakdown'
import { OrderProductCard } from '../shared/OrderProductCard'

type OrderDetailsProps = {
  balance: MoneyAmount | null;
  purchase: MarketplacePurchase;
  isMobileView?: boolean;
}

export const OrderDetails = ({
  balance,
  purchase,
  isMobileView = false,
}: OrderDetailsProps) => {
  const variant = purchase.variant
  const product = purchase.product

  const productPrice = variant.discounted_price ?? variant.base_price
  const hasCardPayment = (purchase.personal_card_payment_amount?.subunits || 0) > 0

  return (
    <div className={isMobileView ? 'flex flex-col' : 'flex flex-col h-full'}>
      <div className={isMobileView ? 'flex flex-col gap-4 mt-4' : 'flex flex-col mt-24 gap-6 px-6'}>
        <h1 className='heading-sm'>Order summary</h1>
        <div className='flex flex-col gap-4'>
          <OrderProductCard
            productBrand={product.product_brand}
            productSlug={product.slug}
            variantName={variant.name}
            variantBasePrice={variant.base_price}
            variantDiscountedPrice={variant.discounted_price ?? null}
            variantThumbnailImageUrl={variant.thumbnail_image_urls[0]}
          />
          <div className='h-[1px] bg-gray-200' />
          {balance && <CurrentBalance balance={balance} />}
          {hasCardPayment && (
            <>
              <div className='h-[1px] bg-gray-200' />
              <div className='flex flex-col gap-1 flex-1'>
                <span className='body-bold'>Payment details</span>
                <CardPaymentDetails
                  brand={purchase.personal_card_metadata?.card_brand || 'Card'}
                  last4={purchase.personal_card_metadata?.card_last4 || '****'}
                />
              </div>
            </>
          )}
          <div className='h-[1px] bg-gray-200' />
          <CostBreakdown
            subtotal={productPrice.subunits / 100}
            thatchBalance={purchase.thatch_balance_payment_amount.subunits / 100}
            hideSuccessBanner
          />
        </div>
      </div>
    </div>
  )
}
